module.exports = __webpack_public_path__ + "img/siang.bd2d05db.png";